import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { LinkButton } from '@framework/ui/components/button/LinkButton.tsx';
import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';
import { useTranslation } from 'react-i18next';

export interface ISubmissionDelegationButtonProps {
  submission: RichiestaDTO | undefined;
}

/**
 * Pulsante per delegare una richiesta
 */
export function SubmissionDelegationButton(
  props: ISubmissionDelegationButtonProps,
) {
  const { submission } = props;
  const { t } = useTranslation();

  if (!submission) {
    return null;
  }

  return (
    <>
      {/* Per visionare il pulsante la richiesta non deve essere inviata */}
      <LinkButton
        type="primary"
        size="large"
        to={generatePath('/richieste/:id/deleghe', {
          id: submission.id ?? '<unknown>',
        })}
      >
        {t('submission.delegation-button', 'Delega la Richiesta')}
      </LinkButton>
    </>
  );
}
